import React from 'react';

import FilterOption from 'components/Filters/FilterOption';
import { SWITCHES_FIELDS } from '../../../utils';
import { areComponentPropsEqual } from '../../../utils';

const tooltipInfo =
  'Materials have been manually vetted against the GPS Standard and meet baseline compliance requirements. Some compliant SKUs may meet market differentiator compliance, and some may have expired certifications.';

const FilterSwitch = React.memo(
  ({ data: filter, appFilters, onToggleSwitch }) => {
    const isOriginalSwitch = SWITCHES_FIELDS.includes(filter?.field);
    const filterId = isOriginalSwitch
      ? `filter.${filter?.field}=true`
      : filter?.id;
    const isFilterActive = Boolean(appFilters[filterId]);

    const isGps = filter.field?.includes('is_gps_compliant');
    const tooltipData = isGps ? tooltipInfo : undefined;

    const handleChange = () => {
      if (filter == null) {
        return;
      }

      onToggleSwitch?.(
        {
          label: filter?.label,
          value: filter?.value,
          id: filterId,
          field: filter?.field,
        },
        isFilterActive,
      );
    };

    return (
      <FilterOption
        isSwitch
        customSwitchClass={isGps ? 'gps_compliant_switch' : undefined}
        label={filter?.label}
        isSelected={isFilterActive}
        onClick={handleChange}
        switchTooltipContent={tooltipData}
      />
    );
  },
  areComponentPropsEqual,
);

FilterSwitch.displayName = 'FilterSwitch';

export { FilterSwitch };
